export function debounce(func, wait = 100) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}

export function camelCaseToDash(srt) {
  return srt.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function getQueryStringParams() {
  const query = document.location.search;
  return query ? (/^[?#]/.test(query) ? query.slice(1) : query)
    .split('&')
    .reduce((params, param) => {
        let [key, value] = param.split('=');
        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
        return params;
      }, {}
    ) : {}
}
